import { IDENTITY_ACCESS_VOCABULARIES } from './identity-access.js';
import { BUSINESS_PARTNER_VOCABULARIES } from './business-partner.js';
import { LIVE_OPS_VOCABULARIES } from './live-ops.js';
import { PAYMENTS_LEDGER_VOCABULARIES } from './payments-ledger.js';
import { PROMOTIONS_GROWTH_VOCABULARIES } from './promotions-growth.js';
import { SEED_ACTIVITY_VOCABULARIES } from './seed-activity.js';
import { EARNINGS_PAYOUTS_VOCABULARIES } from './earnings-payouts.js';
import { RESERVATIONS_SCHEDULE_VOCABULARIES } from './reservations-schedule.js';
import { MERCHANT_TERMS_VOCABULARIES } from './merchant-terms.js';
import { GEOFENCE_ZONES_VOCABULARIES } from './geofence-zones.js';
import { MERCHANT_STORE_VOCABULARIES } from './merchant-store.js';
import { MERCHANT_ORDERS_VOCABULARIES } from './merchant-orders.js';
import { FARE_QUOTE_VOCABULARIES } from './fare-quote.js';
import { FLEET_MANAGEMENT_VOCABULARIES } from './fleet-management.js';
import { VERIFICATION_CHANNELS_VOCABULARIES } from './verification-channels.js';
import { RISK_SEVERITY_VOCABULARIES } from './risk-severity.js';
import { GEO_PROVIDERS_VOCABULARIES } from './geo-providers.js';
import { RESERVE_ECONOMIC_VOCABULARIES } from './reserve-economic.js';
import { FOOD_EXPERIENCE_VOCABULARIES } from './food-experience.js';
import { GOVERNANCE_MARKET_VOCABULARIES } from './governance-market.js';
import { RIDE_ACTORS_RELATIONS_VOCABULARIES } from './ride-actors-relations.js';
import { TELEMATICS_DISPATCH_VOCABULARIES } from './telematics-dispatch.js';
import { COURIER_OPS_VOCABULARIES } from './courier-ops.js';
import { ALERTS_BOOKING_STATUS_VOCABULARIES } from './alerts-booking-status.js';
/** Slice d of the catalog (D577): the domain files one build front owns register here (keeps fronts off each other's files). */
export const SLICE_D = [
    ...IDENTITY_ACCESS_VOCABULARIES,
    ...BUSINESS_PARTNER_VOCABULARIES,
    ...LIVE_OPS_VOCABULARIES,
    ...PAYMENTS_LEDGER_VOCABULARIES,
    ...PROMOTIONS_GROWTH_VOCABULARIES,
    ...SEED_ACTIVITY_VOCABULARIES,
    ...EARNINGS_PAYOUTS_VOCABULARIES,
    ...RESERVATIONS_SCHEDULE_VOCABULARIES,
    ...MERCHANT_TERMS_VOCABULARIES,
    ...GEOFENCE_ZONES_VOCABULARIES,
    ...MERCHANT_STORE_VOCABULARIES,
    ...MERCHANT_ORDERS_VOCABULARIES,
    ...FARE_QUOTE_VOCABULARIES,
    ...FLEET_MANAGEMENT_VOCABULARIES,
    ...VERIFICATION_CHANNELS_VOCABULARIES,
    ...RISK_SEVERITY_VOCABULARIES,
    ...GEO_PROVIDERS_VOCABULARIES,
    ...RESERVE_ECONOMIC_VOCABULARIES,
    ...FOOD_EXPERIENCE_VOCABULARIES,
    ...GOVERNANCE_MARKET_VOCABULARIES,
    ...RIDE_ACTORS_RELATIONS_VOCABULARIES,
    ...TELEMATICS_DISPATCH_VOCABULARIES,
    ...COURIER_OPS_VOCABULARIES,
    ...ALERTS_BOOKING_STATUS_VOCABULARIES,
];
//# sourceMappingURL=slice-d.js.map